import { useNavigate, useRouter } from '@tanstack/react-router'
import { Bell } from 'lucide-react'
import { Button } from '~/components/ui/button'
import { useTrackedExports } from '~/hooks/use-tracked-exports'
import { inFlightExports } from '~/lib/export-tracker'
import { cn, pluralize } from '~/lib/utils'

/** Écran « Exports » (lot S8.5). */
const EXPORTS_SCREEN_PATH = '/exports'

/**
 * Cloche de l'en-tête (lot S8.4) : compteur des exports en cours lancés depuis l'onglet, lien vers
 * l'écran « Exports ». Tant que cet écran n'est pas livré (S8.5), la cloche ne mène nulle part,
 * comme avant, mais compte déjà.
 */
export function ExportsBell() {
  const inFlight = inFlightExports(useTrackedExports()).length
  const navigate = useNavigate()
  const screenAvailable = EXPORTS_SCREEN_PATH in useRouter().routesByPath
  const label = inFlight > 0 ? `${pluralize(inFlight, 'export')} en cours` : 'Aucun export en cours'

  return (
    <Button
      variant="outline"
      className={cn(
        'relative text-primary hover:text-primary',
        !screenAvailable && 'cursor-not-allowed',
      )}
      size="icon-lg"
      aria-label={label}
      title={label}
      onClick={screenAvailable ? () => void navigate({ href: EXPORTS_SCREEN_PATH }) : undefined}
    >
      <Bell className="size-5" strokeWidth={2} />
      {inFlight > 0 && (
        <span
          aria-hidden
          className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-secondary-orange-600 px-1 text-xs leading-none font-semibold text-white"
        >
          {inFlight}
        </span>
      )}
    </Button>
  )
}
